import { func, number, string } from "prop-types";
import { percentageLevels } from "utils/indicator/indicatorSettings";
import { Card, Heading } from "uikit/components";
import cx from "classnames";
import styles from "./MunicipalityIndicatorCard.module.styl";
import IconTooltip from "uikit/components/IconTooltip/IconTooltip";
import Chart from "react-apexcharts";
import React from "react";

export default function MunicipalityIndicatorCard({
    title,
    percentage,
    numerator,
    denominator,
    info,
    descriptionTitle,
    descriptionText,
    additionalDescriptionText,
    onClick,
    dataTestName,
}) {
    const options = {
        labels: [""],
        fill: {
            type: "solid",
            colors: [percentageLevels.indicatorColor(percentage).color],
        },
        plotOptions: {
            radialBar: {
                hollow: {
                    size: "75%",
                },
                track: {
                    background: "#C4C4C4",
                    strokeWidth: "35%",
                    margin: 2,
                },
                dataLabels: {
                    showOn: "always",
                    value: {
                        offsetY: -5,
                        color: "#082254",
                        fontSize: "24px",
                        show: true,
                        fontFamily: "Montserrat",
                        fontWeight: "600",
                    },
                },
            },
        },
    };
    const series = [percentage];

    return (
        <Card
            borderRadius={"giant"}
            padding={"none"}
            className={cx(styles.form, onClick && styles.link)}
            onClick={onClick}
            borderColor={percentageLevels.indicatorColor(percentage).colorName}
            name={dataTestName}
        >
            <div className={styles.content}>
                <div className={styles.textInfo}>
                    <div className={styles.heading}>
                        <Heading size={"h2"}>{title}</Heading>
                        <div className={styles.icon}>
                            <IconTooltip trigger={"hover"}>
                                <div className={styles.infoPanel}>{info}</div>
                            </IconTooltip>
                        </div>
                    </div>
                    <div className={styles.indicators}>
                        <div className={styles.numerator}>{numerator}</div>
                        {denominator != null && (
                            <div className={styles.denominator}>/{denominator}</div>
                        )}
                    </div>
                    <Heading size={"h3"} className={styles.descriptionTitle}>
                        {descriptionTitle}
                    </Heading>
                    {descriptionText && denominator != null && (
                        <div className={styles.descriptionText}>
                            {descriptionText}: {denominator - numerator}{" "}
                            {additionalDescriptionText != null ? additionalDescriptionText : ""}
                        </div>
                    )}
                </div>
                <div className={styles.chart}>
                    <Chart options={options} series={series} type="radialBar" width="185" />
                </div>
            </div>
        </Card>
    );
}

MunicipalityIndicatorCard.propTypes = {
    title: string.isRequired,
    percentage: number.isRequired,
    numerator: number.isRequired,
    denominator: number,
    info: string.isRequired,
    descriptionTitle: string.isRequired,
    descriptionText: string,
    additionalDescriptionText: string,
    onClick: func,
    dataTestName: string,
};
